import { OrderItem } from '@/data/types/Order';

type Product = {
	name: string;
	price: number;
	code: string;
	thumbnail: string;
	size: string;
	href: string | undefined;
	quantity: number;
};

export const groupAndSumProducts = (products: Product[]) => {
	const groupedProducts: { [key: string]: Product } = {};

	products.forEach((product) => {
		const uniqueKey = `${product.name}-${product.code}-${product.size}`;
		if (groupedProducts[uniqueKey]) {
			groupedProducts[uniqueKey].quantity += product.quantity;
		} else {
			groupedProducts[uniqueKey] = { ...product };
		}
	});

	return Object.values(groupedProducts);
};

export const countGroupProductsByOrderItems = (orderItems: OrderItem[] = []): number => {
	const groupedProducts: { [key: string]: string } = {};

	orderItems.forEach((orderItem) => {
		const uniqueKey = orderItem.partNumber;
		if (!groupedProducts[uniqueKey]) {
			groupedProducts[uniqueKey] = orderItem.partNumber;
		}
	});

	return Object.values(groupedProducts).length;
};
